import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../../../contexts/ThemeContext';
import { useSystemHealthSummary } from '../../../system-health/useSystemHealthSummary';
import { SyncStatsPanel } from '../../../system-health/components/SyncStatsCard';
import { skeletonPulseClass, viewAllLinkClass, widgetCardClass, widgetTitleClass } from '../../themeHelpers';
import { cn } from '../../../../lib/utils';

export interface SyncStatsWidgetProps {
  embedded?: boolean;
  settings?: Record<string, unknown>;
  isEditing?: boolean;
}

const SyncStatsWidget: React.FC<SyncStatsWidgetProps> = ({ embedded }) => {
  const { colors } = useTheme();
  const { data, isLoading, error } = useSystemHealthSummary();
  const cardClass = widgetCardClass(colors, embedded);

  if (isLoading) {
    return (
      <div className={cardClass}>
        <h2 className={`${widgetTitleClass(colors)} mb-3`}>Sync statistics (24h)</h2>
        <div className={`animate-pulse h-28 rounded-lg ${skeletonPulseClass(colors)}`} />
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className={cardClass}>
        <h2 className={widgetTitleClass(colors)}>Sync statistics (24h)</h2>
        <p className={cn('text-sm mt-3', colors.textMuted)}>Unable to load sync statistics.</p>
      </div>
    );
  }

  return (
    <div className={cardClass}>
      <div className="flex items-center justify-between mb-3 flex-shrink-0 gap-2">
        <div className="min-w-0">
          <h2 className={widgetTitleClass(colors)}>Sync statistics (24h)</h2>
          <p className={cn('text-xs mt-0.5', colors.textMuted)}>Rolling 24h — mail synced and sync run counts</p>
        </div>
        <Link to="/admin/email-logs" className={viewAllLinkClass(colors)}>
          Full logs
        </Link>
      </div>
      <SyncStatsPanel syncStats={data.syncStats} embedded />
    </div>
  );
};

export default SyncStatsWidget;
